import React from 'react';
import { useBrand } from '../context/BrandContext';

interface PoweredByProps {
  className?: string;
  logoColorOverride?: 'light' | 'dark' | 'auto'; // Override logo color for special backgrounds
  textColorOverride?: 'white' | 'black' | 'auto'; // Override text color for special backgrounds
  isWelcomeView?: boolean; // Special handling for WelcomeView divider color
}

const PoweredBy: React.FC<PoweredByProps> = ({
  className = "",
  logoColorOverride = 'auto',
  textColorOverride = 'auto',
  isWelcomeView = false
}) => {
  const { isDarkMode } = useBrand();

  const getDividerColorClass = () => {
    if (isWelcomeView) {
      return 'bg-white/20';
    }
    if (textColorOverride === 'white') {
      return 'bg-white/20';
    }
    return 'bg-brand-text-primary/20';
  };

  const getLogoSrc = () => {
    const suffix = logoColorOverride === 'dark' || (logoColorOverride === 'auto' && isDarkMode) 
      ? '-wob.png'
      : '.png';
    return `/pentatonic${suffix}`;
  };

  const getTextColorClass = () => {
    if (textColorOverride === 'white') {
      return 'text-white';
    } else if (textColorOverride === 'black') {
      return 'text-black';
    }
    return 'text-brand-text-primary';
  };
  return (
    <div
      className={`box-border content-stretch flex flex-row gap-6 items-center justify-start p-0 ${className}`}
      data-node-id="73:802"
    >
      <div
        className="box-border content-stretch flex flex-row gap-4 items-center justify-start p-0 relative shrink-0"
        data-node-id="73:804"
      >
        {/* Powered by text and Pentatonic logo */}
        <div
          className={`relative shrink-0 text-[18px] text-center text-nowrap tracking-[0.81px] uppercase font-brand-secondary leading-normal ${getTextColorClass()}`}
          data-node-id="284:5371"
        >
          <p className="block leading-normal whitespace-pre">powered by:</p>
        </div>
        
        {/* Pentatonic Logo */}
        <div className="h-4 relative shrink-0 w-[158px]" data-name="Pentatonic Logo" data-node-id="73:807">
          <div className="absolute flex inset-0 items-center justify-center">
            <div className="flex-none h-4 w-[157.986px]">
              <img 
                alt="Pentatonic Logo" 
                className="block max-w-none w-full h-full object-contain" 
                src={getLogoSrc()} 
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoweredBy;